module.exports = __webpack_public_path__ + "img/brand_middle@2x.7dbb1b83.png";